import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-34737051"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "background-image pt-15" }

import { inject } from "vue";

import HeaderComponent from "@/components/Header/HeaderComponent.vue";
import FooterComponent from "@/components/Footer/FooterComponent.vue";
import OrderForm from "@/components/OrderForm/OrderForm.vue";
import BuyFormBanner from "@/components/BuyNowBanner/BuyBanner.vue";
import PromoComponent from "@/components/Promo/PromoComponent.vue";
import PromoComponentThisIsWhy from "@/components/Promo/PromoComponentThisIsWhy.vue";

const VIEWED_CC_SWAP = "CCSwapShown";


export default /*#__PURE__*/_defineComponent({
  __name: 'LandingPage',
  setup(__props) {

const amplitude: any = inject("$amplitude");

const isEthVm = window.location.search.includes("platform=ethvm");
const isEnkrypt = window.location.search.includes("platform=enkrypt");

if (isEthVm) {
  amplitude.track(`${VIEWED_CC_SWAP}EthVM`);
}
if (isEnkrypt) {
  amplitude.track(`${VIEWED_CC_SWAP}Enkrypt`);
}
if (!isEthVm && !isEnkrypt) {
  amplitude.track(`${VIEWED_CC_SWAP}Web`);
}

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["component--landing-page-old-design", [_ctx.$vuetify.display.mdAndUp ? 'background-lg' : 'background-sm']])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, null, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                cols: "12",
                md: "5",
                lg: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(HeaderComponent)
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                cols: "12",
                md: "7",
                lg: "6"
              }, {
                default: _withCtx(() => [
                  _createVNode(OrderForm)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(PromoComponent)
    ]),
    _createVNode(PromoComponentThisIsWhy),
    _createVNode(BuyFormBanner),
    _createVNode(FooterComponent)
  ], 2))
}
}

})